module.exports = __webpack_public_path__ + "static/media/banner_BonusDice-half.fea85967.png";